import React from 'react';
import { MenuItem } from '@mui/material';
import styles from './styles.module.scss';

const StandardMenuItem = ({
  id,
  icon,
  label,
  action,
  link,
  isMobile = false,
  isNested = false,
  topIconPos = '2px',
  className = ''
}) => {
  const normalizedLabel = typeof label === 'string' ? label : String(label);
  const idf = (normalizedLabel.toLowerCase()).split(' ').join('-');

  const baseClassName = isNested
    ? (isMobile ? styles.extendedMenuItemMobile : styles.extendedMenuItem)
    : (isMobile ? styles.menuItemMobile : styles.menuItem);
  const itemClassName = className ? `${baseClassName} ${className}` : baseClassName;

  const renderLabel = () => {
    return !!icon
      ? (
        <>
          <span style={{ marginRight: '8px', position: 'relative', top: topIconPos }}>{icon}</span>
          {normalizedLabel}
        </>
      )
      : <>{normalizedLabel}</>;
  };

  const renderMenuItem = () => {
    return (
      <MenuItem
        id={id}
        className={itemClassName}
        data-testid={`menuitem-main-header-menu${isMobile ? '-mobile' : ''}-${idf}`}
        onClick={action}
      >
        {!!link ? (
          <a
            href={link}
            onClick={(e) => { e.preventDefault(); }}
            className={styles.anchor}
            data-testid={`link-main-header-menu${isMobile ? '-mobile' : ''}-${idf}`}
          >
            {renderLabel()}
          </a>
        ) : renderLabel()}
      </MenuItem>
    );
  };

  return (
    <>
      {isNested ? (
        <div className={isMobile ? styles.childMenuWrapperMobile : styles.childMenuWrapper}>
          {renderMenuItem()}
        </div>
      ) : renderMenuItem()}
    </>
  );
};

export default StandardMenuItem;
